import { render } from "./index.vue?vue&type=template&id=4f72a483"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"pages/EndataAuth/Account/App/components/profile/my/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f72a483"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f72a483', __exports__)) {
    api.reload('4f72a483', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4f72a483", () => {
    api.rerender('4f72a483', render)
  })

}


export default __exports__